// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__xIb-i","menu__navigation":"Menu_menu__navigation__vhsTg","menu__actions":"Menu_menu__actions__Pb4-F"};